var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rounds),function(n){return _c('v-icon',{key:n,attrs:{"medium":"","color":_vm.mycolor(n)}},[_vm._v(" mdi-check-circle ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }